import React, { useEffect, useState } from "react";
import { Card, Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Flex from "components/shared-components/Flex";
import utils from "utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { find } from "lodash";
import { FIRESTORE_USER_ANALYTICS_TABLE } from "../../../../constants/FirestoreConstant";
import { useFirestoreConnect } from "react-redux-firebase";

const Customers = () => {
  const webshopUsers = useSelector((state) => state.firestoreReducer.ordered.webshopUsers);
  const loyaltyUsers = useSelector((state) => state.firestoreReducer.ordered.loyaltyUsers);
  const [customerList, setCustomerList] = useState(null);
  const [filteredCustomerList, setFilteredCustomerList] = useState(null);
  const { t } = useTranslation();

  // Connect to Firestore to get all RFM analyses
  useFirestoreConnect([{ collection: FIRESTORE_USER_ANALYTICS_TABLE }]);

  const userAnalytics = useSelector((state) => state.firestoreReducer.ordered.userAnalytics || []);

  useEffect(() => {
    if (!!webshopUsers && !!loyaltyUsers) {
      const mergedCustomerList = [];
      webshopUsers.map((user) => {
        const loyaltyUser = find(loyaltyUsers, (u) => u.id === user.id);
        const userAnalyticsObject = find(userAnalytics, (ua) => ua.id === user.id);
        if (!!loyaltyUser) {
          const mergedUser = {
            ...user,
            currentPoints: loyaltyUser.currentPoints,
            totalPointsEarned: loyaltyUser.totalPointsEarned,
            totalPointsSpent: loyaltyUser.totalPointsSpent,
          };
          if (userAnalyticsObject) {
            mergedUser["currentRfm"] = userAnalyticsObject.currentRfm;
            mergedUser["rfmHistory"] = userAnalyticsObject.rfmHistory;
            mergedUser["rfmMetrics"] = userAnalyticsObject.rfmMetrics;
          }
          mergedCustomerList.push(mergedUser);
        } else mergedCustomerList.push(user);
      });

      setCustomerList(mergedCustomerList);
      setFilteredCustomerList(mergedCustomerList);
    }
  }, [webshopUsers, loyaltyUsers]);

  const tableColumns = [
    {
      title: t("email"),
      dataIndex: "email",
      render: (data) => <span>{data}</span>,
      sorter: (a, b) => utils.antdTableSorter(a, b, "email"),
    },
    {
      title: t("name"),
      dataIndex: "firstName",
      render: (_, data) =>
        data?.firstName && data?.lastName ? <span>{data.firstName + " " + data.lastName}</span> : <span> - </span>,
    },
    {
      title: t("customer_segment"),
      dataIndex: ["currentRfm", "segment"],
    },
    {
      title: t("customer.loyalty_points_current"),
      dataIndex: "currentPoints",
      render: (data) => (data ? <span>{data}</span> : <span> - </span>),
    },
    {
      title: t("customer.loyalty_points_total"),
      dataIndex: "totalPointsEarned",
      render: (data) => (data ? <span>{data}</span> : <span> - </span>),
      sorter: (a, b) => utils.antdTableSorter(a, b, "totalPointsEarned"),
    },
    {
      title: t("customer.loyalty_points_spent"),
      dataIndex: "totalPointsSpent",
      render: (data) => (data ? <span>{data}</span> : <span> - </span>),
      sorter: (a, b) => utils.antdTableSorter(a, b, "totalPointsSpent"),
    },
  ];

  const onSearch = (e) => {
    const value = e.currentTarget.value;
    const data = utils.wildCardSearchOnCustomer(customerList, value);
    setFilteredCustomerList(data);
  };

  return (
    <Card>
      <Flex alignItems="center" justifyContent="between" mobileFlex={false}>
        <Flex className="mb-1" mobileFlex={false}>
          <div className="mr-md-3 mb-3">
            <Input placeholder={t("search")} prefix={<SearchOutlined />} onChange={(e) => onSearch(e)} />
          </div>
        </Flex>
      </Flex>
      <div className="table-responsive">
        <Table
          showSorterTooltip={false}
          columns={tableColumns}
          dataSource={filteredCustomerList}
          rowKey="email"
          scroll={{ x: 1300 }}
        />
      </div>
    </Card>
  );
};

export default Customers;
